import { checkStringSimilarity } from './checkSimilarity'

const popularEmailDomains = [
  'gmail',
  'yahoo',
  'outlook',
  'hotmail',
  'icloud',
  'aol',
  'yandex',
  'mail',
  'protonmail',
  'proton',
  'zoho',
] as const

const isTopLevelDomainValid = (topLevelDomain: string, domain: typeof popularEmailDomains[number]) => {
  const validTLDs = ['com']

  if (domain === 'proton') validTLDs.push('me')

  return validTLDs.includes(topLevelDomain)
}

/**
 * Checks for typos in a given email.
 * This checks against a list of specific popular domains like `gmail`, `outlook` and others (go to definition to see full list).
 *
 * @param email The email to check
 * @returns An object telling if it's a possible typo and the suggested email (if any)
 */
export function checkEmailTypo(email: string, minSimilarity = 0.5) {
  let isLikelyTypo = false
  let suggestedEmail: string | undefined

  const domain = email.replace(/^.*?@|\..*?$/gm, '')

  const { similarity, bestMatch } = checkStringSimilarity(domain, [...popularEmailDomains])

  if (bestMatch) {
    // This is in case the user types some domain variation we don't cover
    // e.g.: hotmail.co.uk
    const topLevelDomainsAmount = email.replace(/^.*@.*?\./gm, '').split('.').length

    if (topLevelDomainsAmount === 1) {
      const topLevelDomain = email.replace(/^.*@.*?\./gm, '')

      isLikelyTypo = (similarity >= minSimilarity && similarity < 1) || (similarity === 1 && !isTopLevelDomainValid(topLevelDomain, bestMatch as typeof popularEmailDomains[number]))
      suggestedEmail = isLikelyTypo ? email.replace(/@.*$/gm, `@${bestMatch}.com`) : undefined
    }
  }

  return {
    isLikelyTypo,
    suggestedEmail,
  }
}
